import { LABELS_BY_CODES, DEFAULT_CODE } from './config';

export default function (code) {
    if (Object.keys(LABELS_BY_CODES).indexOf(code) >= 0) {
        return LABELS_BY_CODES[code];
    }
    return LABELS_BY_CODES[DEFAULT_CODE];
}
